<template>
  <v-container v-resize="onResize">
    <v-row>
      <v-col cols="12">
        <div class="_title">
          <v-icon small>mdi-magnify</v-icon>
          {{ $t('rtrck.title.search.detail') }}
        </div>
      </v-col>
    </v-row>
    <progress-linear :active="loading"></progress-linear>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <div class="box">
            <v-row>
              <v-col cols="2">
                <v-row>
                  <v-col cols="12">
                    <span>{{ $t('rtrck.system') }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-row>
                  <v-col cols="6">
                    <span>{{ $t('rtrck.field.title.select.entity') }}</span>
                  </v-col>
                  <v-col cols="6">
                    <span>{{ entityNameLabel }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6"> </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-row>
                  <v-col cols="12">
                    <v-text-field :value="systemId" class="text-full-width" outlined dense hide-details readonly></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-row>
                  <v-col cols="6">
                    <v-select v-model="entityKind" :items="entities" item-text="label" item-value="entity" solo dense hide-details class="mr-1 w-auto"></v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="entityName" @blur="nameToUpper" class="text-full-width" outlined dense hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col cols="12">
                    <div>
                      <v-btn @click="search(entityKind, entityName)" color="primary" x-small class="icon-right">
                        <v-icon small>mdi-magnify</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="item-title">
          <h2>
            <img v-show="'USER' == this.srchTitleKind" src="@/assets/image/diagram/node_user_icon.png" class="item-image" />
            <img v-show="'CROL' == this.srchTitleKind" src="@/assets/image/diagram/node_composite_role_icon.png" class="item-image" />
            <img v-show="'SROL' == this.srchTitleKind" src="@/assets/image/diagram/node_single_role_icon.png" class="item-image" />
            <img v-show="'CPRF' == this.srchTitleKind" src="@/assets/image/diagram/node_composite_profile_icon.png" class="item-image" />
            <img v-show="'SPRF' == this.srchTitleKind" src="@/assets/image/diagram/node_single_profile_icon.png" class="item-image" />
            <span v-html="`${srchTitle}`" />
          </h2>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card :height="height" elevation="0" class="mt-2">
          <v-tabs height="35" v-model="activeTab" slider-size="3" :background-color="color(3)" class="rounded-0">
            <v-tab v-show="showUser">
              <img src="@/assets/image/diagram/node_user_icon.png" class="tab-image" />
              {{ $t('rtrck.tab.title.user') }}
            </v-tab>
            <v-tab v-show="showRole">{{ $t('rtrck.tab.title.assigned.user') }}</v-tab>
            <v-tab v-show="showProfile">{{ $t('rtrck.tab.title.assigned.user') }}</v-tab>
            <v-tab v-show="showRole">
              <img v-show="'CROL' == this.srchTitleKind" src="@/assets/image/diagram/node_composite_role_icon.png" class="tab-image" />
              <img v-show="'SROL' == this.srchTitleKind" src="@/assets/image/diagram/node_single_role_icon.png" class="tab-image" />
              {{ $t('rtrck.tab.title.role') }}
            </v-tab>
            <v-tab v-show="showProfile">
              <img v-show="'CPRF' == this.srchTitleKind" src="@/assets/image/diagram/node_composite_profile_icon.png" class="tab-image" />
              <img v-show="'SPRF' == this.srchTitleKind" src="@/assets/image/diagram/node_single_profile_icon.png" class="tab-image" />
              {{ $t('rtrck.tab.title.profile') }}
            </v-tab>
            <v-tab v-show="showUser || showRole">{{ $t('rtrck.tab.title.role') }} / {{ $t('rtrck.tab.title.menu') }}</v-tab>
            <v-tab v-show="showUser || showRole">{{ $t('rtrck.tab.title.tcode.compare') }}</v-tab>
            <v-tab v-show="showUser || showRole">{{ $t('rtrck.tab.title.role') }} / {{ $t('rtrck.tab.title.authorization') }}</v-tab>
            <v-tab v-show="showUser || showRole || showProfile">{{ $t('rtrck.tab.title.profile') }} / {{ $t('rtrck.tab.title.authorization') }}</v-tab>
            <v-tab v-show="showUser || showRole || showProfile">{{ $t('rtrck.tab.title.profile') }} / {{ $t('rtrck.tab.title.tcode') }}</v-tab>
            <v-tab-item v-show="showUser" transition="false" reverse-transition="false">
              <search-tab-user-form :user="user"></search-tab-user-form>
            </v-tab-item>
            <v-tab-item v-show="showRole" transition="false" reverse-transition="false">
              <search-tab-role-user-grid :height="height" :roleUser="ruList"></search-tab-role-user-grid>
            </v-tab-item>
            <v-tab-item v-show="showProfile" transition="false" reverse-transition="false">
              <search-tab-profile-user-grid :height="height" :profileUser="puList"></search-tab-profile-user-grid>
            </v-tab-item>
            <v-tab-item v-show="showRole" transition="false" reverse-transition="false">
              <search-tab-role-form :role="role"></search-tab-role-form>
            </v-tab-item>
            <v-tab-item v-show="showProfile" transition="false" reverse-transition="false">
              <search-tab-profile-form :profile="profile"></search-tab-profile-form>
            </v-tab-item>
            <v-tab-item v-show="showUser || showRole" transition="false" reverse-transition="false">
              <search-tab-role-menu :height="height" :roleTree="roleTree"></search-tab-role-menu>
            </v-tab-item>
            <v-tab-item v-show="showUser || showRole" transition="false" reverse-transition="false">
              <search-tab-tcode-compare :height="height" :roleTree="roleTree"></search-tab-tcode-compare>
            </v-tab-item>
            <v-tab-item v-show="showUser || showRole" transition="false" reverse-transition="false">
              <search-tab-role-authorization :height="height" :roleTree="roleTree"></search-tab-role-authorization>
            </v-tab-item>
            <v-tab-item v-show="showUser || showRole || showProfile" transition="false" reverse-transition="false">
              <search-tab-profile-authorization :height="height" :profileTree="profileTree"></search-tab-profile-authorization>
            </v-tab-item>
            <v-tab-item v-show="showUser || showRole || showProfile" transition="false" reverse-transition="false">
              <search-tab-profile-tcode :height="height" :profileTree="profileTree"></search-tab-profile-tcode>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { api } from '@/api/common/instances';
import { isEmpty } from 'lodash';
import SearchTabUserForm from './SearchTabUserForm';
import SearchTabRoleForm from './SearchTabRoleForm';
import SearchTabProfileForm from './SearchTabProfileForm';
import SearchTabRoleUserGrid from './SearchTabRoleUserGrid';
import SearchTabProfileUserGrid from './SearchTabProfileUserGrid';
import SearchTabRoleMenu from './SearchTabRoleMenu';
import SearchTabTcodeCompare from './SearchTabTcodeCompare';
import SearchTabRoleAuthorization from './SearchTabRoleAuthorization';
import SearchTabProfileAuthorization from './SearchTabProfileAuthorization';
import SearchTabProfileTcode from './SearchTabProfileTcode';
export default {
  components: {
    SearchTabUserForm,
    SearchTabRoleForm,
    SearchTabProfileForm,
    SearchTabRoleUserGrid,
    SearchTabProfileUserGrid,
    SearchTabRoleMenu,
    SearchTabTcodeCompare,
    SearchTabRoleAuthorization,
    SearchTabProfileAuthorization,
    SearchTabProfileTcode,
  },
  data() {
    return {
      loading: false,
      height: 0,
      svrYmdhms: this.$route.query.ymd,
      systemId: this.$route.query.sstm,
      mandt: this.$route.query.mandt,
      entities: [
        { entity: 'USER', label: this.$t('rtrck.title.user') },
        { entity: 'CROL', label: this.$t('rtrck.title.crol') },
        { entity: 'SROL', label: this.$t('rtrck.title.srol') },
        { entity: 'CPRF', label: this.$t('rtrck.title.cprf') },
        { entity: 'SPRF', label: this.$t('rtrck.title.sprf') },
      ],
      imgSrcBase: '@/assets/image/diagram/',
      srchTitle: '',
      entityKind: this.$route.query.entt,
      entityName: this.$route.query.name,
      srchTitleKind: this.$route.query.entt,
      entityNameLabel: '',
      activeTab: 0,
      showUser: false,
      showRole: false,
      showProfile: false,
      srchData: {},
      user: {},
      role: {},
      profile: {},
      ruList: [],
      puList: [],
      roleTree: [],
      profileTree: [],
    };
  },
  methods: {
    setKindValues(kind, name) {
      this.srchTitleKind = kind;
      if ('USER' == kind) this.srchTitle = `${this.$t('rtrck.title.user')}: ${name}`;
      else if ('CROL' == kind) this.srchTitle = `${this.$t('rtrck.title.crol')}: ${name}`;
      else if ('SROL' == kind) this.srchTitle = `${this.$t('rtrck.title.srol')}: ${name}`;
      else if ('CPRF' == kind) this.srchTitle = `${this.$t('rtrck.title.cprf')}: ${name}`;
      else if ('SPRF' == kind) this.srchTitle = `${this.$t('rtrck.title.sprf')}: ${name}`;
      if ('USER' == kind) {
        this.showUser = true;
        this.activeTab = 0;
        this.showRole = false;
        this.showProfile = false;
      } else if ('CROL' == kind || 'SROL' == kind) {
        this.showUser = false;
        this.showRole = true;
        this.activeTab = 3;
        this.showProfile = false;
      } else if ('CPRF' == kind || 'SPRF' == kind) {
        this.showUser = false;
        this.showRole = false;
        this.showProfile = true;
        this.activeTab = 4;
      }
      if ('USER' == this.entityKind) this.entityNameLabel = this.$t('rtrck.field.title.bname');
      else if ('CROL' == this.entityKind || 'SROL' == this.entityKind) this.entityNameLabel = this.$t('rtrck.field.title.agr.name');
      else if ('CPRF' == this.entityKind || 'SPRF' == this.entityKind) this.entityNameLabel = this.$t('rtrck.field.title.profn');
    },
    // Complex search의 결과 srchData의 모든 속성은 값이 없더라도 비어있는 Array ([])를 리턴하므로
    // 따로 null 체크를 하지 않아도 된다.
    setUser() {
      if (!isEmpty(this.srchData) && this.srchData.userList.length > 0) this.user = this.srchData.userList[0];
      else this.user = {};
    },
    setRole() {
      if (!isEmpty(this.srchData)) {
        if ('CROL' == this.entityKind && this.srchData.crolList.length > 0) this.role = this.srchData.crolList[0];
        else if ('SROL' == this.entityKind && this.srchData.srolList.length > 0) this.role = this.srchData.srolList[0];
      } else {
        this.role = {};
      }
    },
    setProfile() {
      if (!isEmpty(this.srchData)) {
        if ('CPRF' == this.entityKind && this.srchData.cprfList.length > 0) this.profile = this.srchData.cprfList[0];
        else if ('SPRF' == this.entityKind && this.srchData.sprfList.length > 0) this.profile = this.srchData.sprfList[0];
      } else {
        this.profile = {};
      }
    },
    setRoleUser() {
      if (!isEmpty(this.srchData)) {
        if ('CROL' == this.entityKind) this.ruList = this.srchData.cr2uList;
        else if ('SROL' == this.entityKind) this.ruList = this.srchData.sr2uList;
      } else {
        this.ruList = [];
      }
    },
    setProfileUser() {
      if (!isEmpty(this.srchData)) {
        if ('CPRF' == this.entityKind) this.puList = this.srchData.cp2uList;
        else if ('SPRF' == this.entityKind) this.puList = this.srchData.sp2uList;
      } else {
        this.puList = [];
      }
    },
    setRoleTree() {
      let roleTree = [];
      if (isEmpty(this.srchData)) return roleTree;
      roleTree = roleTree.concat(this.srchData.crolList);
      this.matchRoleRelation(this.srchData.crolList, this.srchData.cr2uList);
      this.matchRoleRelation(this.srchData.srolList, this.srchData.sr2uList);
      this.appendChildRole(this.srchData.crolList, this.srchData.srolList);
      this.appendRootNotChild(roleTree, this.srchData.srolList);
      this.roleTree = roleTree;
    },
    async setProfileTree() {
      let profileTree = [];
      if (isEmpty(this.srchData)) return profileTree;
      profileTree = profileTree.concat(this.srchData.cprfList);
      this.matchProfileRelation(this.srchData.cprfList, this.srchData.cp2uList);
      this.matchProfileRelation(this.srchData.sprfList, this.srchData.sp2uList);
      this.appendChildProfile(this.srchData.cprfList, this.srchData.sprfList);
      this.appendRootNotChild(profileTree, this.srchData.sprfList);
      if (this.srchData.srolList.length > 0) {
        let srolNameList = '';
        srolNameList = this.srchData.srolList.reduce((acc, elm) => {
          return acc.concat(',', elm.agrName);
        }, '');
        // Single role에 대응되는 single profile 목록을 구해 profileTree에 루트 노드로 붙인다.
        const profileList = await this.getProfileOfSingleRole(srolNameList.substring(1)); // 맨앞의 comma 제거.
        profileList.forEach(elm => {
          elm.leaf = true;
        });
        profileTree = profileTree.concat(profileList);
      }
      this.profileTree = profileTree;
    },
    // 사용자가 Role에 할당된 것과 관련된 정보를 옮겨준다.
    matchRoleRelation(rList, ruList) {
      if (rList.length == 0 || ruList.length == 0) return;
      ruList.forEach(ru => {
        for (var r of rList) {
          if (r.agrName == ru.agrName) {
            r.assignDatim = ru.changeDatim;
            r.fromDatim = ru.fromDatim;
            r.toDatim = ru.toDatim;
            break;
          }
        }
      });
    },
    // Composite role에 딸린 single role들을 찾아 자식 노드로 매단다.
    appendChildRole(cList, sList) {
      sList.forEach(elm => {
        elm.isChild = false;
        elm.leaf = true;
        elm.children = [];
      });
      if (cList.length == 0 || sList.length == 0) return;
      cList.forEach(c => {
        let children = [];
        sList.forEach(s => {
          if (c.agrName == s.parentAgr) {
            s.isChild = true;
            s.leaf = true;
            s.children = [];
            children.push(s);
          }
        });
        c.children = children;
        if (children.length > 0) c.leaf = false;
        else c.leaf = true;
      });
    },
    // Single role/profile인데 Composite role/profile의 자식이 아닌 것들은 트리 루트에 추가한다.
    appendRootNotChild(tree, list) {
      list.forEach(elm => {
        if (elm.isChild == false) {
          elm.leaf = true;
          tree.push(elm);
        }
      });
    },
    // 사용자가 Profile에 할당된 것과 관련된 정보를 옮겨준다.
    matchProfileRelation(pList, puList) {
      if (pList.length == 0 || puList.length == 0) return;
      puList.forEach(pu => {
        for (var p of pList) {
          if (p.profn == pu.profn) {
            p.assignDatim = pu.modDatim;
            break;
          }
        }
      });
    },
    // Composite profile에 딸린 single profile들을 찾아 자식 노드로 매단다.
    appendChildProfile(cList, sList) {
      sList.forEach(elm => {
        elm.isChild = false;
        elm.leaf = true;
        elm.children = [];
      });
      if (cList.length == 0 || sList.length == 0) return;
      cList.forEach(c => {
        let children = [];
        sList.forEach(s => {
          if (c.profn == s.parentProfn) {
            s.isChild = true;
            s.leaf = true;
            s.children = [];
            children.push(s);
          }
        });
        c.children = children;
        if (children.length > 0) c.leaf = false;
        else c.leaf = true;
      });
    },
    nameToUpper() {
      this.entityName = this.entityName.toUpperCase();
    },
    color(saturation) {
      return this.$vuetify.theme.isDark ? `grey darken-${saturation}` : `grey lighten-${saturation - 2}`;
    },
    async search(kind, name) {
      if (isEmpty(name)) {
        this.$snackbar(this.$t('rtrck.msg.input.entity.name'));
        return;
      }
      // Complex search는 기본적으로 like 검색을 한다.
      // 하지만, 이 detail 팝업 화면에서는 하나의 대상만을 상대로 질의한다.
      // 따라서, name에 '%'가 들어 있으면 이를 제거한다.
      name = name.replace('%', '');
      const param = new URLSearchParams();
      param.append('svrYmdhms', this.$route.query.ymd);
      param.append('sstmId', this.$route.query.sstm);
      param.append('mandt', this.$route.query.mand);
      if ('USER' == kind) param.append('user', name);
      else if ('CROL' == kind) param.append('crol', name);
      else if ('SROL' == kind) param.append('srol', name);
      else if ('CPRF' == kind) param.append('cprf', name);
      else if ('SPRF' == kind) param.append('sprf', name);

      this.loading = true;
      // eslint-disable-next-line prettier/prettier
      const { data } = await api.post('/rtrck/search/complex-search', param);
      // eslint-disable-next-line prettier/prettier
      if (('USER' == kind && (isEmpty(data.userList) || data.userList.length == 0))
       || ('CROL' == kind && (isEmpty(data.crolList) || data.crolList.length == 0))
       || ('SROL' == kind && (isEmpty(data.srolList) || data.srolList.length == 0))
       || ('CPRF' == kind && (isEmpty(data.cprfList) || data.cprfList.length == 0))
       || ('SPRF' == kind && (isEmpty(data.sprfList) || data.sprfList.length == 0))) {
        this.$snackbar(this.$t('common.no.srch.rslt'));
        this.loading = false;
        return;
      }

      this.srchData = data;
      this.setUser();
      this.setRole();
      this.setProfile();
      this.setRoleUser();
      this.setProfileUser();
      this.setRoleTree();
      this.setProfileTree();

      this.setKindValues(kind, name);
      this.loading = false;
    },
    // Single role에 대응되는 single profile 목록을 읽어온다.
    async getProfileOfSingleRole(agrNameList) {
      const { data } = await api.get('/rtrck/search/prfl-of-srol', {
        params: {
          svrYmdhms: this.$route.query.ymd,
          sstmId: this.$route.query.sstm,
          mandt: this.$route.query.mand,
          agrNameList: agrNameList,
        },
      });
      return data;
    },
    onResize() {
      this.height = window.innerHeight - 190;
    },
  },
  async created() {
    await this.search(this.$route.query.entt, this.$route.query.name);
  },
};
</script>

<style scoped>
.container {
  padding: 0 10px 10px 10px;
  margin: 0;
  max-width: 100%;
}
._title {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2;
}
.item-title {
  float: left;
  height: 40px;
  line-height: 20px;
}
.item-image {
  height: 20px;
  width: 20px;
  vertical-align: middle;
  margin: 10px;
}
.tab-image {
  height: 20px;
  width: 20px;
  vertical-align: middle;
  margin-right: 10px;
}
.text-full-width {
  width: auto;
}
.icon-right {
  float: right;
}
</style>
